import useBotControlStore from "../../storeModules/useBotControlStore";
import useConsorcioStore from "../../storeModules/useConsorcioStore";
import { TipoSimulacaoEnum } from "../../utils/constants";
import { CategoriaPagamento } from "../../utils/constants";
import findStep from "../../screens/bot/stepModules/findStep";

const TypesOfPlans = () => {
  const options = [
    {
      text: "PLANO PAGA METADE",
      action: () => {
        const consorcioData = useConsorcioStore.getState();

        useConsorcioStore.setState({
          tipoPlano: TipoSimulacaoEnum.CREDITO_PAGAMETADE,
          categoriaId:
            CategoriaPagamento[TipoSimulacaoEnum.CREDITO_PAGAMETADE][
              consorcioData.tipoBem
            ],
        });

        useBotControlStore.setState({
          currentStep: findStep("pergunta_valor_credito").index,
        });
      },
    },
    {
      text: "PLANO INTEGRAL",
      action: () => {
        const consorcioData = useConsorcioStore.getState();

        useConsorcioStore.setState({
          tipoPlano: TipoSimulacaoEnum.CREDITO_INTEGRAL,
          categoriaId:
            CategoriaPagamento[TipoSimulacaoEnum.CREDITO_INTEGRAL][
              consorcioData.tipoBem
            ],
        });

        useBotControlStore.setState({
          currentStep: findStep("pergunta_valor_credito").index,
        });
      },
    },
  ];

  return options;
};

export default TypesOfPlans;
